import { LocalizationService } from '../services/localization.service';

export class DynamicLocaleIdProvider extends String {
  constructor(protected localizationService: LocalizationService) {
    super('');
  }

  public override toString(): string {
    return this.localizationService.formatCulture;
  }
}
